module.exports = __webpack_public_path__ + "img/UM6PLOGO.3d2ef872.png";